<template>
<div class="battle" :style="{ height: `${height}px` }">
  <!-- <Suspension v-if="platform !== 'notInDingTalk'" @share="getShareContent"/> -->
  <iframe width="100%" frameborder="0" class="iframe" height="100%" marginheight="0" marginwidth="0"  :src="CALDNDAREHOST"/>
</div>
</template>
<script>
import { CALDNDAREHOST } from '../../utils/config'
import DDMixins from '../../minixs/ddMixis'
export default {
  mixins: [DDMixins],
  data () {
    return {
      CALDNDAREHOST,
      mobile: '',
      height: window.innerHeight
    }
  },
  mounted () {
    const { path } = this.$route.query
    let IP = CALDNDAREHOST
    if (path && path !== '/') {
      IP = `${IP}${path}`
    }
    this.CALDNDAREHOST = IP
  }
}
</script>
<style lang="scss" scoped>
.battle {
  height: 100%;
  width: 100%;
  background: #fff;
  .iframe {
    border:none;
    border-style: none;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
}
</style>
